import { render, staticRenderFns } from "./supplierEditTabInformation.vue?vue&type=template&id=4a540d70&scoped=true&"
import script from "./supplierEditTabInformation.vue?vue&type=script&lang=js&"
export * from "./supplierEditTabInformation.vue?vue&type=script&lang=js&"
import style0 from "./supplierEditTabInformation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a540d70",
  null
  
)

export default component.exports